import { TEXT_CONSTANTS_COD_PORTAL, EXPORT_TYPES } from "constants/CODPortalConstants";
import AppConstants from "../constants";

interface ExportUrls {
    DRIVER: string;
    ORDER: string;
    SUMMARY: string;
}

export const handleOrdersHeaderButtonClick = (
  btnObj: any,
  driversActiveFilters: any,
  dashboardHub: any,
  datePickerValue: any,
  handleExcelExport: (filters: any, hub: any, dateValue: any, type: string, country?: string) => void,
  country?: string,
) => {
  if (btnObj && btnObj.type) {
    switch (btnObj.type) {
      case TEXT_CONSTANTS_COD_PORTAL.EXCEL:
        handleExcelExport(
          driversActiveFilters,
          dashboardHub,
          datePickerValue,
          EXPORT_TYPES.DRIVER,
          country,
        );
        break;
      case TEXT_CONSTANTS_COD_PORTAL.EXCEL_ORDERS:
        handleExcelExport(
          driversActiveFilters,
          dashboardHub,
          datePickerValue,
          EXPORT_TYPES.ORDER,
          country,
        );
        break;
      case TEXT_CONSTANTS_COD_PORTAL.EXCEL_SUMMARY:
        handleExcelExport(
          driversActiveFilters,
          dashboardHub,
          datePickerValue,
          EXPORT_TYPES.SUMMARY,
          country,
        );
        break;
      default:
        break;
    }
  }
};

export const getExportUrl = (type: string, urls: ExportUrls): string => {
    switch (type) {
        case EXPORT_TYPES.DRIVER:
            return urls.DRIVER;
        case EXPORT_TYPES.ORDER:
            return urls.ORDER;
        case EXPORT_TYPES.SUMMARY:
            return urls.SUMMARY;
        default:
            throw new Error(`Invalid export type: ${type}`);
    }
};